export const version = '1.2'
export const lastUpdated = 'September, 2024'
